"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const DashboardNoDataInfo = ({ type, finalWord = 'available' }) => (react_1.default.createElement("div", { className: 'no-data-info' },
    react_1.default.createElement("div", null,
        "No ",
        react_1.default.createElement("strong", null, type),
        " ",
        finalWord)));
exports.default = DashboardNoDataInfo;
